import type { PublicStatusResponse } from '@nadoutong/contracts';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { useSession } from '../hooks/useSession.tsx';
import { getNadoutongPublicStatus, getPlatformHealth } from './status.ts';

export const NADOUTONG_STATUS_QUERY_KEY = ['status', 'nadoutong'] as const;
export const PLATFORM_HEALTH_QUERY_KEY = ['status', 'platform-health'] as const;

export function useNadoutongPublicStatus(): UseQueryResult<PublicStatusResponse> {
  const { fetchImpl } = useSession();
  return useQuery({
    queryKey: NADOUTONG_STATUS_QUERY_KEY,
    queryFn: ({ signal }) => getNadoutongPublicStatus(fetchImpl, signal),
    staleTime: 120_000,
  });
}

export function usePlatformHealth(): UseQueryResult<{ readonly ok: true }> {
  const { fetchImpl } = useSession();
  return useQuery({
    queryKey: PLATFORM_HEALTH_QUERY_KEY,
    queryFn: ({ signal }) => getPlatformHealth(fetchImpl, signal),
    staleTime: 120_000,
  });
}
